module.exports = __webpack_public_path__ + "img/d2.9506ecf0.jpg";